<template>
  <div class="container-fluid p-0 position-relative">
    <div class="w-100 radio-masthead-content">
      <div class="owl-carousel owl-theme" id="radiofeaturedcar">
        <div
          class="item"
          v-for="item_featured in masthead_featured"
          :key="item_featured.id"
          @click="goTo(checkLink(item_featured))"
        >
          <div class="item_img">
            <img
              v-bind:src="item_featured.img_link"
              @error="imageLoadError($event)"
            />
            <div class="overlay"></div>
          </div>
          <div class="item-details">
            <div class="w-100">
              <div class="w-100 mb-2">
                <p
                  class="main-title"
                  v-if="item_featured.data.title"
                  :title="item_featured.data.title"
                >
                  <!-- <Trunquee :text="item_featured.data.title" :speed="120" /> -->
                  {{ truncateString(item_featured.data.title, 60) }}
                </p>
              </div>
              <div class="details-wrapper mb-3">
                <!-- description -->
                <div class="w-100 mt-2">
                  <p class="desc" v-if="item_featured.data.description">
                    {{ truncateString(item_featured.data.description, 200) }}
                  </p>
                </div>
              </div>
              <div class="btn-wrapper">
                <div class="play-btn-wrapper mr-2">
                  <img src="../../../../assets/rtmklik/icon_play.svg" alt="" />
                </div>
                <!-- <div class="bookmark-btn-wrapper">
                  <img
                    src="../../../../assets/rtmklik/icon_bookmark.svg"
                    alt=""
                  />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="owl-theme">
        <div class="owl-controls d-md-block d-none">
          <div class="custom-nav owl-nav"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import ChevronRight from "../../../../assets/rtmklik/chevron-right.svg";
import ChevronLeft from "../../../../assets/rtmklik/chevron-left.svg";

export default {
  data: function() {
    return {
      masthead_featured: [],
    };
  },
  created: function() {
    this.$store.dispatch("fetchMastheadsFeatured", { self: this });
  },
  methods: {
    filterMastheadFeatured() {
      var vm = this;
      vm.masthead_featured = this.$store.state.masthead_featured.data;

      var store = [];
      var imgurl;

      vm.masthead_featured.forEach((item) => {
        item["img_link"] = vm.rtmImgLinkFiltering(item.data.images, "800x0");
        store.push(item);
      });

      vm.masthead_featured = store;
      Vue.nextTick(
        function() {
          vm.installOwlCarouselForMasthead("#radiofeaturedcar");
        }.bind(vm)
      );

      setTimeout(
        function() {
          this.item_loaded = true;
        }.bind(this),
        2000
      );
    },

    goTo(link) {
      this.$router.push(link);
    },
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      // console.log(JSON.stringify(item,null,2));

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (item.idSchema == "204") {
        //pod episode
        // get main podcast id id=382&eps_id=385
        var podcast_id = item.data.podcast.id;
        link = "/podcastplayer?id=" + podcast_id + "&eps_id=" + item.id;
        // console.log(link);
      }

      return link;
    },

    installOwlCarouselForMasthead: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: false,
        center: true,
        navText: [
          `<div class="border-nav"><img src=${ChevronLeft} /></div>`,
          `<div class="border-nav"><img src=${ChevronRight} /></div>`,
        ],
        navContainer: ".radio-masthead-content .custom-nav",
        dots: true,
        margin: 0,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: true,
          },
          768: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: false,
          },
          990: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: true,
          },
          1600: {
            items: 1,
            stagePadding: 280,
            margin: 30,
            loop: true,
            nav: true,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.item {
  cursor: pointer;
  position: relative;
}
.item .item_img {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-top: 59.14%;
}
.item .item_img img {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 48%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #111319;
  -webkit-mask-image: linear-gradient(
    to top,
    #111319 24%,
    rgba(0, 0, 0, 0) 88%
  );
  mask-image: linear-gradient(to top, #111319 24%, rgba(0, 0, 0, 0) 88%);
  z-index: 2;
}

.item-details {
  position: absolute;
  top: 46%;
  left: 24rem;
  transform: translate(-50%, -50%);
  align-items: center;
  max-width: 600px;
  display: flex;
  justify-content: flex-start;
  z-index: 3;
}

.btn-wrapper {
  width: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.play-btn-wrapper {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #dae12f;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
.play-btn-wrapper img {
  margin-left: 6px;
  width: 100% !important;
}
.bookmark-btn-wrapper {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
.bookmark-btn-wrapper img {
  width: 100% !important;
  margin-left: 4px;
}
.list-wrapper {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: #dae12f;
}
.list-wrapper span {
  font-family: "HelveticaNeue-Bold";
  font-size: 12px;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #000;
}
.popularity-wrapper,
.category-wrapper {
  width: auto;
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: #373946;
}
.popularity-wrapper span,
.category-wrapper span {
  font-family: "HelveticaNeue-Bold";
  font-size: 12px;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
}
.main-title {
  font-family: "HelveticaNeue-Bold";
  font-size: 24px;
  font-weight: bold;
  line-height: 20px;
  text-align: left;
  color: #fff;
}
.desc {
  font-family: "HelveticaNeue-Bold";
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  text-align: left;
  color: #fff;
}
@media only screen and (max-width: 992px) {
}
@media only screen and (max-width: 768px) {
  .play-btn-wrapper,
  .bookmark-btn-wrapper {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
  .play-btn-wrapper img,
  .bookmark-btn-wrapper img {
    width: 100% !important;
  }
  .item-details {
    left: 17rem !important;
  }
}
@media only screen and (max-width: 576px) {
  .item .item_img {
    width: 100%;
    overflow: hidden;
    position: relative;
    padding-top: 126.6%;
  }
  .item .item_img img {
    height: 100%;
    object-fit: cover;
  }
  .overlay {
    height: 100%;
  }
  .item-details {
    left: 46% !important;
    width: 80%;
  }
}
</style>
<style>
.radio-masthead-content .owl-theme .owl-dots {
  position: absolute;
  bottom: 24%;
  right: -24px;
  transform: translateX(-50%);
}
.radio-masthead-content .owl-theme .owl-dots .owl-dot span {
  width: 7px;
  height: 7px;
  margin: 0 4px;
  border-radius: 2px;
  background-color: #fff;
}

.radio-masthead-content .owl-theme .owl-dots .owl-dot.active span,
.radio-masthead-content .owl-theme .owl-dots .owl-dot:hover span {
  background: #dae12f;
  width: 14px;
  height: 7px;
  border-radius: 2px;
  margin: 0 4px;
}

.radio-masthead-content .owl-theme .custom-nav .owl-prev,
.radio-masthead-content .owl-theme .custom-nav .owl-next {
  position: absolute;
  color: inherit;
  background: rgba(0, 0, 0, 0);
  border: none;
  z-index: 100;
  top: 50%;
  transform: translateY(-50%);
  border-radius: none;
  width: 100px;
  outline: none;
}
.radio-masthead-content .owl-theme .custom-nav .owl-prev .border-nav,
.radio-masthead-content .owl-theme .custom-nav .owl-next .border-nav {
  width: 46px;
  height: 46px;
}
.radio-masthead-content .owl-theme .custom-nav .owl-prev .border-nav i,
.radio-masthead-content .owl-theme .custom-nav .owl-next .border-nav i {
  font-size: 2.4rem;
  color: #dae12f;
  padding: 0 10px;
}
.radio-masthead-content .owl-theme .custom-nav .owl-prev {
  left: -14px;
  display: flex;
  justify-content: center;
}
.radio-masthead-content .owl-theme .custom-nav .owl-next {
  right: -14px;
  display: flex;
  justify-content: center;
}
.radio-masthead-content .owl-theme .owl-nav [class*="owl-"]:hover {
  background: unset !important;
}
.radio-masthead-content
  .owl-theme
  .owl-stage-outer
  .owl-stage
  .owl-item:not(.center)
  > div {
  opacity: 0.25;
  z-index: 5;
}
@media only screen and (max-width: 768px) {
  .radio-masthead-content .owl-theme .owl-dots {
    bottom: 18%;
    right: -48px;
  }
}
@media only screen and (min-width: 1600px) {
  .radio-masthead-content .owl-theme .owl-dots {
    left: 50%;
    bottom: 8%;
  }
}
</style>
